import useSWR, { trigger } from "swr";
import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const plant = (token, id) =>
  Manager.client(token).get(`${Endpoints.plant.plants}${id}/`);
const plants = (token) => Manager.client(token).get(Endpoints.plant.plants);
const createPlant = (token, values) =>
  Manager.client(token).post(Endpoints.plant.create, values);
const updatePlant = (token, values) =>
  Manager.client(token).post(Endpoints.plant.update, values);
const refreshPlants = (token) =>
  trigger(`${Endpoints.plant.plants}/${token.access}`);
const refreshPlant = (token, id) =>
  trigger(`${Endpoints.plant.plants}/${token.access}/${id}`);
const deletePlant = (token, values) =>
  Manager.client(token).delete(`${Endpoints.plant.delete}${values.plant}/`);

export const UsePlants = ({ access }) => {
  const { data, error } = useSWR(
    `${Endpoints.plant.plants}/${access}`,
    () => plants(access),
    { refreshInterval: 5000 },
  );

  return {
    content: data
      ? data.data.data.map((item) => ({
          ...item,
          ekloks: item.ekloks.map((item) => ({
            ...item,
            connected: undefined,
            alarm_list: item.alarm_list
              ? JSON.parse(
                  item.alarm_list
                    .replace(/'/g, '"')
                    .replace(/"[{"/g, '[{"').replace(/}]",/g, "}],")
                    .replace(/}]}"/g, "}]"),
                )
              : null,
          })),
        }))
      : [],
    error,
    loading: !error && !data,
  };
};

export const UsePlant = ({ access }, id) => {
  const { data, error } = useSWR(
    `${Endpoints.plant.plants}/${access}/${id}`,
    () => plant(access, id),
  );

  return {
    content: data
      ? {
          ...data.data.data,
          ekloks: data.data.data.ekloks.map((item) => ({
            ...item,
            connected: false,
            alarm_list: item.alarm_list
              ? JSON.parse(
                  item.alarm_list
                    .replace(/'/g, '"')
                    .replace(/"[{"/g, '[{"').replace(/}]",/g, "}],")
                    .replace(/}]}"/g, "}]"),
                )
              : null,
          })),
        }
      : null,
    error,
    loading: !error && !data,
  };
};

export const Request = {
  createPlant,
  updatePlant,
  refreshPlants,
  refreshPlant,
  deletePlant,
};
